module.exports = __webpack_public_path__ + "img/Southwest Quinoa Bowl-Chicken.bf1c6158.jpg";